import type * as Types from '../generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type ProductExternalSearchQueryVariables = Types.Exact<{
  query: Types.ProductExternalSearchQueryInput;
}>;

export type ProductExternalSearchQuery = {
  __typename?: 'Query';
  productExternalSearch: {
    __typename?: 'ProductExternalSearchResult';
    offers: Array<{
      __typename?: 'ProductExternalOffer';
      id: string;
      productId: string;
      productTitle: string;
      sellerName: string;
      sellerUrl?: string | null;
      productThumbnail: { __typename?: 'PhotoSummary'; url: string };
      productRating?: { __typename?: 'ProductRating'; id: string; averageRating: number; reviewsCount: number } | null;
      sellerFullPrice: {
        __typename?: 'MonetaryValue';
        valueInMinorUnits: number;
        floatingPointDecimalString: string;
        currency?: { __typename?: 'Currency'; code: string; places: number } | null;
      };
      sellerSalePrice?: {
        __typename?: 'MonetaryValue';
        valueInMinorUnits: number;
        floatingPointDecimalString: string;
        currency?: { __typename?: 'Currency'; code: string; places: number } | null;
      } | null;
    }>;
  };
};

export type ProductExternalByIdQueryVariables = Types.Exact<{
  productId: Types.Scalars['String'];
}>;

export type ProductExternalByIdQuery = {
  __typename?: 'Query';
  productExternalById: {
    __typename?: 'ProductExternal';
    id: string;
    title: string;
    description?: string | null;
    photos: Array<{ __typename?: 'PhotoSummary'; url: string }>;
    rating?: { __typename?: 'ProductRating'; id: string; averageRating: number; reviewsCount: number } | null;
    sellers: Array<{
      __typename?: 'ProductExternalSeller';
      id: string;
      name: string;
      url: string;
      fullPrice: {
        __typename?: 'MonetaryValue';
        valueInMinorUnits: number;
        floatingPointDecimalString: string;
        currency?: { __typename?: 'Currency'; code: string; places: number } | null;
      };
      salePrice?: {
        __typename?: 'MonetaryValue';
        valueInMinorUnits: number;
        floatingPointDecimalString: string;
        currency?: { __typename?: 'Currency'; code: string; places: number } | null;
      } | null;
    }>;
  };
};

export type SeoRedirectByLocatorQueryVariables = Types.Exact<{
  url: Types.Scalars['String'];
}>;

export type SeoRedirectByLocatorQuery = {
  __typename?: 'Query';
  productCatalogCategoryByLocator?: { __typename?: 'ProductCatalogCategory'; id: string; seoRedirectPath?: string | null } | null;
};

export type CoreCatalogCategoryFieldsFragment = {
  __typename?: 'ProductCatalogCategory';
  id: string;
  title: string;
  heroText?: string | null;
  publicUrlPath: string;
  isFeatured?: boolean | null;
  thumbnail?: { __typename?: 'PhotoSummary'; url: string } | null;
  showcase?: { __typename?: 'ProductCatalogCategoryShowcase'; title?: string | null; image?: { __typename?: 'Photo'; id: string; url: string } | null } | null;
};

export type CoreCatalogCategoryFieldsWithChildrenFragment = {
  __typename?: 'ProductCatalogCategory';
  id: string;
  title: string;
  heroText?: string | null;
  publicUrlPath: string;
  isFeatured?: boolean | null;
  children: Array<{
    __typename?: 'ProductCatalogCategory';
    id: string;
    title: string;
    heroText?: string | null;
    publicUrlPath: string;
    isFeatured?: boolean | null;
    children: Array<{
      __typename?: 'ProductCatalogCategory';
      id: string;
      title: string;
      heroText?: string | null;
      publicUrlPath: string;
      isFeatured?: boolean | null;
      children: Array<{
        __typename?: 'ProductCatalogCategory';
        id: string;
        title: string;
        heroText?: string | null;
        publicUrlPath: string;
        isFeatured?: boolean | null;
        thumbnail?: { __typename?: 'PhotoSummary'; url: string } | null;
        showcase?: { __typename?: 'ProductCatalogCategoryShowcase'; title?: string | null; image?: { __typename?: 'Photo'; id: string; url: string } | null } | null;
      }>;
      thumbnail?: { __typename?: 'PhotoSummary'; url: string } | null;
      showcase?: { __typename?: 'ProductCatalogCategoryShowcase'; title?: string | null; image?: { __typename?: 'Photo'; id: string; url: string } | null } | null;
    }>;
    thumbnail?: { __typename?: 'PhotoSummary'; url: string } | null;
    showcase?: { __typename?: 'ProductCatalogCategoryShowcase'; title?: string | null; image?: { __typename?: 'Photo'; id: string; url: string } | null } | null;
  }>;
  thumbnail?: { __typename?: 'PhotoSummary'; url: string } | null;
  showcase?: { __typename?: 'ProductCatalogCategoryShowcase'; title?: string | null; image?: { __typename?: 'Photo'; id: string; url: string } | null } | null;
};

export type ProductCatalogByLocatorQueryVariables = Types.Exact<{
  url: Types.Scalars['String'];
}>;

export type ProductCatalogByLocatorQuery = {
  __typename?: 'Query';
  productCatalogCategoryByLocator?: {
    __typename?: 'ProductCatalogCategory';
    id: string;
    title: string;
    heroText?: string | null;
    publicUrlPath: string;
    isFeatured?: boolean | null;
    children: Array<{
      __typename?: 'ProductCatalogCategory';
      id: string;
      title: string;
      heroText?: string | null;
      publicUrlPath: string;
      isFeatured?: boolean | null;
      children: Array<{
        __typename?: 'ProductCatalogCategory';
        id: string;
        title: string;
        heroText?: string | null;
        publicUrlPath: string;
        isFeatured?: boolean | null;
        children: Array<{
          __typename?: 'ProductCatalogCategory';
          id: string;
          title: string;
          heroText?: string | null;
          publicUrlPath: string;
          isFeatured?: boolean | null;
          thumbnail?: { __typename?: 'PhotoSummary'; url: string } | null;
          showcase?: { __typename?: 'ProductCatalogCategoryShowcase'; title?: string | null; image?: { __typename?: 'Photo'; id: string; url: string } | null } | null;
        }>;
        thumbnail?: { __typename?: 'PhotoSummary'; url: string } | null;
        showcase?: { __typename?: 'ProductCatalogCategoryShowcase'; title?: string | null; image?: { __typename?: 'Photo'; id: string; url: string } | null } | null;
      }>;
      thumbnail?: { __typename?: 'PhotoSummary'; url: string } | null;
      showcase?: { __typename?: 'ProductCatalogCategoryShowcase'; title?: string | null; image?: { __typename?: 'Photo'; id: string; url: string } | null } | null;
    }>;
    thumbnail?: { __typename?: 'PhotoSummary'; url: string } | null;
    showcase?: { __typename?: 'ProductCatalogCategoryShowcase'; title?: string | null; image?: { __typename?: 'Photo'; id: string; url: string } | null } | null;
  } | null;
};

export type ProductCatalogDepartmentsQueryVariables = Types.Exact<{
  storefront?: Types.InputMaybe<Types.CatalogStorefront>;
  types: Array<Types.CatalogTreeRootInput> | Types.CatalogTreeRootInput;
}>;

export type ProductCatalogDepartmentsQuery = {
  __typename?: 'Query';
  productCatalogCategoryTreeRoot: {
    __typename?: 'ProductCatalogCategory';
    id: string;
    title: string;
    heroText?: string | null;
    publicUrlPath: string;
    isFeatured?: boolean | null;
    children: Array<{
      __typename?: 'ProductCatalogCategory';
      id: string;
      title: string;
      heroText?: string | null;
      publicUrlPath: string;
      isFeatured?: boolean | null;
      children: Array<{
        __typename?: 'ProductCatalogCategory';
        id: string;
        title: string;
        heroText?: string | null;
        publicUrlPath: string;
        isFeatured?: boolean | null;
        children: Array<{
          __typename?: 'ProductCatalogCategory';
          id: string;
          title: string;
          heroText?: string | null;
          publicUrlPath: string;
          isFeatured?: boolean | null;
          thumbnail?: { __typename?: 'PhotoSummary'; url: string } | null;
          showcase?: { __typename?: 'ProductCatalogCategoryShowcase'; title?: string | null; image?: { __typename?: 'Photo'; id: string; url: string } | null } | null;
        }>;
        thumbnail?: { __typename?: 'PhotoSummary'; url: string } | null;
        showcase?: { __typename?: 'ProductCatalogCategoryShowcase'; title?: string | null; image?: { __typename?: 'Photo'; id: string; url: string } | null } | null;
      }>;
      thumbnail?: { __typename?: 'PhotoSummary'; url: string } | null;
      showcase?: { __typename?: 'ProductCatalogCategoryShowcase'; title?: string | null; image?: { __typename?: 'Photo'; id: string; url: string } | null } | null;
    }>;
    thumbnail?: { __typename?: 'PhotoSummary'; url: string } | null;
    showcase?: { __typename?: 'ProductCatalogCategoryShowcase'; title?: string | null; image?: { __typename?: 'Photo'; id: string; url: string } | null } | null;
  };
};

export const CoreCatalogCategoryFieldsFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CoreCatalogCategoryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductCatalogCategory' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heroText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicUrlPath' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isFeatured' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'thumbnail' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'showcase' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'image' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const CoreCatalogCategoryFieldsWithChildrenFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CoreCatalogCategoryFieldsWithChildren' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductCatalogCategory' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CoreCatalogCategoryFields' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'children' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CoreCatalogCategoryFields' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'children' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CoreCatalogCategoryFields' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'children' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CoreCatalogCategoryFields' } }] },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CoreCatalogCategoryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductCatalogCategory' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heroText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicUrlPath' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isFeatured' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'thumbnail' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'showcase' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'image' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const ProductExternalSearchDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ProductExternalSearch' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'query' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductExternalSearchQueryInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'productExternalSearch' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'query' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'query' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'offers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProductExternalOfferSummary' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ProductExternalOfferSummary' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductExternalOffer' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'productId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'productTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'productThumbnail' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'productRating' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'averageRating' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reviewsCount' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'sellerName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sellerUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sellerFullPrice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'currency' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'places' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sellerSalePrice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'currency' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'places' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useProductExternalSearchQuery__
 *
 * To run a query within a React component, call `useProductExternalSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductExternalSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductExternalSearchQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useProductExternalSearchQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProductExternalSearchQuery, ProductExternalSearchQueryVariables>) {
  return ApolloReactHooks.useQuery<ProductExternalSearchQuery, ProductExternalSearchQueryVariables>(ProductExternalSearchDocument, baseOptions);
}
export function useProductExternalSearchLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProductExternalSearchQuery, ProductExternalSearchQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<ProductExternalSearchQuery, ProductExternalSearchQueryVariables>(ProductExternalSearchDocument, baseOptions);
}
export type ProductExternalSearchQueryHookResult = ReturnType<typeof useProductExternalSearchQuery>;
export type ProductExternalSearchLazyQueryHookResult = ReturnType<typeof useProductExternalSearchLazyQuery>;
export type ProductExternalSearchQueryResult = Apollo.QueryResult<ProductExternalSearchQuery, ProductExternalSearchQueryVariables>;
export const ProductExternalByIdDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ProductExternalById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'productId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'productExternalById' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'productId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'productId' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProductExternalSummary' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ProductExternalSummary' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductExternal' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'photos' }, selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }] } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rating' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'averageRating' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reviewsCount' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sellers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'fullPrice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'currency' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'places' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'salePrice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'currency' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'places' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useProductExternalByIdQuery__
 *
 * To run a query within a React component, call `useProductExternalByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductExternalByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductExternalByIdQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useProductExternalByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProductExternalByIdQuery, ProductExternalByIdQueryVariables>) {
  return ApolloReactHooks.useQuery<ProductExternalByIdQuery, ProductExternalByIdQueryVariables>(ProductExternalByIdDocument, baseOptions);
}
export function useProductExternalByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProductExternalByIdQuery, ProductExternalByIdQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<ProductExternalByIdQuery, ProductExternalByIdQueryVariables>(ProductExternalByIdDocument, baseOptions);
}
export type ProductExternalByIdQueryHookResult = ReturnType<typeof useProductExternalByIdQuery>;
export type ProductExternalByIdLazyQueryHookResult = ReturnType<typeof useProductExternalByIdLazyQuery>;
export type ProductExternalByIdQueryResult = Apollo.QueryResult<ProductExternalByIdQuery, ProductExternalByIdQueryVariables>;
export const SeoRedirectByLocatorDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SeoRedirectByLocator' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'url' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'productCatalogCategoryByLocator' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'url' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'url' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'seoRedirectPath' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useSeoRedirectByLocatorQuery__
 *
 * To run a query within a React component, call `useSeoRedirectByLocatorQuery` and pass it any options that fit your needs.
 * When your component renders, `useSeoRedirectByLocatorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSeoRedirectByLocatorQuery({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function useSeoRedirectByLocatorQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SeoRedirectByLocatorQuery, SeoRedirectByLocatorQueryVariables>) {
  return ApolloReactHooks.useQuery<SeoRedirectByLocatorQuery, SeoRedirectByLocatorQueryVariables>(SeoRedirectByLocatorDocument, baseOptions);
}
export function useSeoRedirectByLocatorLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SeoRedirectByLocatorQuery, SeoRedirectByLocatorQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<SeoRedirectByLocatorQuery, SeoRedirectByLocatorQueryVariables>(SeoRedirectByLocatorDocument, baseOptions);
}
export type SeoRedirectByLocatorQueryHookResult = ReturnType<typeof useSeoRedirectByLocatorQuery>;
export type SeoRedirectByLocatorLazyQueryHookResult = ReturnType<typeof useSeoRedirectByLocatorLazyQuery>;
export type SeoRedirectByLocatorQueryResult = Apollo.QueryResult<SeoRedirectByLocatorQuery, SeoRedirectByLocatorQueryVariables>;
export const ProductCatalogByLocatorDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ProductCatalogByLocator' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'url' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'productCatalogCategoryByLocator' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'url' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'url' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CoreCatalogCategoryFieldsWithChildren' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CoreCatalogCategoryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductCatalogCategory' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heroText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicUrlPath' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isFeatured' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'thumbnail' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'showcase' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'image' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CoreCatalogCategoryFieldsWithChildren' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductCatalogCategory' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CoreCatalogCategoryFields' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'children' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CoreCatalogCategoryFields' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'children' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CoreCatalogCategoryFields' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'children' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CoreCatalogCategoryFields' } }] },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useProductCatalogByLocatorQuery__
 *
 * To run a query within a React component, call `useProductCatalogByLocatorQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductCatalogByLocatorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductCatalogByLocatorQuery({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function useProductCatalogByLocatorQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProductCatalogByLocatorQuery, ProductCatalogByLocatorQueryVariables>) {
  return ApolloReactHooks.useQuery<ProductCatalogByLocatorQuery, ProductCatalogByLocatorQueryVariables>(ProductCatalogByLocatorDocument, baseOptions);
}
export function useProductCatalogByLocatorLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProductCatalogByLocatorQuery, ProductCatalogByLocatorQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<ProductCatalogByLocatorQuery, ProductCatalogByLocatorQueryVariables>(ProductCatalogByLocatorDocument, baseOptions);
}
export type ProductCatalogByLocatorQueryHookResult = ReturnType<typeof useProductCatalogByLocatorQuery>;
export type ProductCatalogByLocatorLazyQueryHookResult = ReturnType<typeof useProductCatalogByLocatorLazyQuery>;
export type ProductCatalogByLocatorQueryResult = Apollo.QueryResult<ProductCatalogByLocatorQuery, ProductCatalogByLocatorQueryVariables>;
export const ProductCatalogDepartmentsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ProductCatalogDepartments' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'storefront' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'CatalogStorefront' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'types' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'ListType', type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CatalogTreeRootInput' } } } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'productCatalogCategoryTreeRoot' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'types' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'types' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'storefront' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'storefront' } } },
            ],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CoreCatalogCategoryFieldsWithChildren' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CoreCatalogCategoryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductCatalogCategory' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heroText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicUrlPath' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isFeatured' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'thumbnail' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'showcase' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'image' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CoreCatalogCategoryFieldsWithChildren' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductCatalogCategory' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CoreCatalogCategoryFields' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'children' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CoreCatalogCategoryFields' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'children' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CoreCatalogCategoryFields' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'children' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CoreCatalogCategoryFields' } }] },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useProductCatalogDepartmentsQuery__
 *
 * To run a query within a React component, call `useProductCatalogDepartmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductCatalogDepartmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductCatalogDepartmentsQuery({
 *   variables: {
 *      storefront: // value for 'storefront'
 *      types: // value for 'types'
 *   },
 * });
 */
export function useProductCatalogDepartmentsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProductCatalogDepartmentsQuery, ProductCatalogDepartmentsQueryVariables>) {
  return ApolloReactHooks.useQuery<ProductCatalogDepartmentsQuery, ProductCatalogDepartmentsQueryVariables>(ProductCatalogDepartmentsDocument, baseOptions);
}
export function useProductCatalogDepartmentsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProductCatalogDepartmentsQuery, ProductCatalogDepartmentsQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<ProductCatalogDepartmentsQuery, ProductCatalogDepartmentsQueryVariables>(ProductCatalogDepartmentsDocument, baseOptions);
}
export type ProductCatalogDepartmentsQueryHookResult = ReturnType<typeof useProductCatalogDepartmentsQuery>;
export type ProductCatalogDepartmentsLazyQueryHookResult = ReturnType<typeof useProductCatalogDepartmentsLazyQuery>;
export type ProductCatalogDepartmentsQueryResult = Apollo.QueryResult<ProductCatalogDepartmentsQuery, ProductCatalogDepartmentsQueryVariables>;
